import {Component, Inject, Input, input, OnInit, output, ChangeDetectionStrategy} from '@angular/core';

import {DATE_FORMAT, TIME_FORMAT} from '@app/api/constants';
import {DatePipe} from '@angular/common';
import {WaButtonDirective, WaCardDirective, WaIconDirective} from "angular-awesome";
import {StaffMember} from "../../../../api/models/staff-member";

@Component({
    selector: 'app-staffmember-list-element',
    templateUrl: './staffmember-list-element.component.html',
    styleUrls: ['./staffmember-list-element.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DatePipe, WaCardDirective, WaIconDirective, WaButtonDirective]
})
export class StaffmemberListElementComponent implements OnInit {

  // TODO: Skipped for migration because:
  //  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
  //  and migrating would break narrowing currently.
  @Input() staffmember!: StaffMember;
  readonly selected = input<boolean>(false);
  readonly showSupervisionGradingControls = input<boolean>(false);
  readonly compact   = input<boolean>(false);

  displayAssignments = output<StaffMember>();
  editSupervisions = output<StaffMember>();
  editCorrections = output<StaffMember>();
  resetStaffMember = output<StaffMember>();


  tooltipText: string = '';
  statusIcon: string = '';

  constructor(@Inject(DATE_FORMAT) public dateFormat: string,
              @Inject(TIME_FORMAT) public timeFormat: string) {}

  ngOnInit(): void {}
}
